const TAB_GAP_PX = 4;
const OVERFLOW_BUTTON_PX = 100;
const END_SLOT_RESERVE_PX = 140;

export function countVisibleTabs(input: {
  itemCount: number;
  itemWidths: readonly number[];
  rowWidth: number;
  hasEndSlot: boolean;
  activeIndex: number;
}): number {
  if (input.itemCount <= 0) return 0;
  const toolsWidth = input.hasEndSlot ? END_SLOT_RESERVE_PX : 0;
  const available = input.rowWidth - toolsWidth;
  if (available <= 0) return input.itemCount;

  const fit = (maxWidth: number): number => {
    let used = 0;
    for (let i = 0; i < input.itemWidths.length; i += 1) {
      used += input.itemWidths[i] + TAB_GAP_PX;
      if (used > maxWidth) return Math.max(1, i);
    }
    return input.itemCount;
  };

  let count = fit(available);
  if (count < input.itemCount) {
    count = fit(available - OVERFLOW_BUTTON_PX);
  }
  if (input.activeIndex >= count) {
    count = Math.min(input.itemCount, input.activeIndex + 1);
  }
  return count;
}
